/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import { withOktaAuth } from "@okta/okta-react";
import _ from "lodash";
import React from "react";
import { Login } from "../../../core/authentication";
import i18n from "../../../i18n";
import { getShareableLink } from "../../../services/aboToolsService";
import {
  getLanguage,
  removeHybrisSession,
} from "../../../services/commerceServices/accessToken";
import {
  createSuggesticUser,
  setUserLanguage,
} from "../../../services/suggesticServices";
import PickSurveyComponent from "../../achievers";
import TermsConditions from "../../terms-conditions";
import MessageStrip from "../message-strip";
import SaveResultsPopup from "../popup/save-results";

// Infterface for ResultsHeader State
interface ResultsHeaderState { }
interface ResultsHeaderProps {
  selectedType?: any;
  handleCallBack?: (state: any, e?: any) => void;
  handleCartClick?: (e?: any) => void;
  handleCartKeyPress?: (event: any) => any;
  t?: any;
  foodsLoader?: boolean;
  productsLoader?: boolean;
  tipsLoader?: boolean;
}

interface ResultsHeaderState {
  hamburgerVisible: boolean;
  successfullyCopied: boolean;
  isPopupOpen: boolean;
  isTermsVisible: boolean;
  isCopyLinkPopUpOpen: boolean;
  linkToBeCopied: string;
  isPickSurveyVisible: boolean;
  surveyPath: string;
}

/**
 * ResultsHeader component.
 *
 * @namespace ResultsHeader
 */
class ResultsHeader extends React.Component<
  any & ResultsHeaderProps,
  ResultsHeaderState
> {
  node: any;
  constructor(props: any & ResultsHeaderProps) {
    super(props);
    this.state = {
      hamburgerVisible: false,
      successfullyCopied: false,
      isPopupOpen: false,
      isTermsVisible: false,
      isCopyLinkPopUpOpen: false,
      linkToBeCopied: "",
      isPickSurveyVisible: false,
      surveyPath: "",
    };
  }

  componentDidUpdate = () => {
    if (this.state.hamburgerVisible) {
      // this.getCartProductsList();
      // attach/remove event handler
      document.addEventListener("click", this.handleOutsideClick, true);
      document.addEventListener(
        "keydown",
        (e: any) => {
          if (e.key === "Escape") {
            this.handleOutsideClick(e);
          }
        },
        true
      );
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
      document.removeEventListener(
        "keydown",
        (e: any) => {
          if (e.key === "Escape") {
            this.handleOutsideClick(e);
          }
        },
        false
      );
    }
  };

  handleOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.node) {
      if (this.node.contains(e.target)) {
        return;
      }
      this.setState({
        hamburgerVisible: false,
      });
    }
  };

  executeCallback = (data: any, e?: any) => {
    if (this.props.handleCallBack) {
      this.props.handleCallBack(data);
    }
  };
  executeCallbackOnKeypress = (event: any, data: any) => {
    if (event.key === "Enter") {
      this.executeCallback(data);
    }
  };

  handleHambuurgerMenu = (e?: any) => {
    this.setState({
      hamburgerVisible: !this.state.hamburgerVisible,
    });
  };
  /**
   * This method is used for handle language popup
   *
   */
  updateContentLanguageOnClick = (e?: any) => {
    //languageType is fetched from session storage here

    const language = sessionStorage.getItem("languageTypeOfApp") || "en-us";
    const languageType =
      language === null ? "es-us" : language === "en-us" ? "es-us" : "en-us";
    i18n.changeLanguage(languageType);
    //languageType is set on session storage here
    sessionStorage.setItem("languageTypeOfApp", languageType);

    //suggestic call for updating user language
    if (localStorage.getItem("uniqueId")) {
      setUserLanguage();
    }
  };
  /**
   * This method is used for handle authentication in hamburger menu
   *
   */
  handleUserAuthentication = async (isAuthenticated: boolean, e?: any) => {
    let oktaCred = localStorage.getItem("okta-token-storage");
    localStorage.setItem(
      "previousPath",
      this.props.history?.location?.pathname?.includes("summary")
        ? "/results"
        : this.props.history?.location?.pathname
    );
    if (oktaCred) {

      //clear the currect user data in the local and session storage
      let currentLanguage =
          sessionStorage.getItem("languageTypeOfApp") || "en-us";
      localStorage.clear();
      sessionStorage.clear();
      sessionStorage.setItem("languageTypeOfApp", currentLanguage);
      localStorage.setItem("logout", "true");
      localStorage.removeItem("user-info");

      //redirect to the correct logout using gluu
      if (typeof window !== 'undefined') {
        window.location.href = 
        `${process.env.REACT_APP_LOGOUT_BASE_URL}` + '/signout?clientapp=' + `${process.env.REACT_APP_CLIENT_APP_NAME}` + '&redirect=' + encodeURIComponent(window.location.origin + '/loginsuccessful');
      }
    } else {
      const userConsent = localStorage.getItem("user-consent");
      localStorage.removeItem("results");
      localStorage.removeItem("totalCartProductsCount");
      if (!userConsent) {
        this.setState(
          {
            isTermsVisible: true,
          },
          async () => {
            // sessionStorage.setItem("before-login-consent", "true");
            await Login(this.props.oktaAuth);
            // window.location.reload();
          }
        );
      } else {
        await Login(this.props.oktaAuth).then(() => {
          // createSuggesticUser()
        });
      }
    }
  };
  /**
   * This function associated with the shareAssesment Button
   * Only works as per button visibility condition
   */

  handleShareAssessment = async (e?: any) => {
    await getShareableLink().then((res: any) => {
      if (res?.data?.sharableLink) {
        //console.log("link copied..");
        this.setState({
          linkToBeCopied: res?.data?.sharableLink,
          isCopyLinkPopUpOpen: true,
          isPopupOpen: false,
        });
      }
    });
  };

  handleAssessmentClick: any = () => {
    let recoResult = localStorage.getObj("reco-result");
    let isConsentAccepted = localStorage.getItem("user-consent");
    let isAssessmentContinued = sessionStorage.getItem("foundationalPageCount");

    // let isAssessmentDone =
    //   recoResult && !_.isEmpty(recoResult?.data?.getRecommendation)
    //     ? true
    //     : false;
    let currentPath = window.location.pathname === "/results" ? true : false;

    if (recoResult && !isConsentAccepted) {
      localStorage.removeItem("reco-result");
    }

    //handle retake assessment
    if ((recoResult || isAssessmentContinued) && isConsentAccepted) {
      this.setState({
        // isPopupOpen: true,
        // isCopyLinkPopUpOpen: false,
        isPickSurveyVisible: true,
      });
      //  sessionStorage.setItem("foundationalPageCount", JSON.stringify(0));
      //  localStorage.removeItem("reco-result");
      //  localStorage.removeItem("user-response");
      //  this.props.history.push("/foundational");
    }
    //handles take assessment when user has accepted consent
    else if (!currentPath && isConsentAccepted) {
      // console.log("called from home and assessment done");
      this.props?.handleAssessmentClick(false);
    }
    //handles take assessment when user has not accepted consent
    else {
      // console.log("called from home and assessment not done");
      this.props?.handleAssessmentClick(true);
    }
  };

  closePopup = (e: any) => {
    if (e?.target?.accessKey === "copyClicked") {
      this.setState(
        {
          successfullyCopied: true,
        },
        () =>
          setTimeout(() => this.setState({ successfullyCopied: false }), 3000)
      );
    }
    this.setState(
      {
        isPopupOpen: false,
        isCopyLinkPopUpOpen: false,
      },
      () => {
        // sessionStorage.setItem("saveResults", "false");
        // sessionStorage.removeItem("login-session-expired")
        //if user denied to relogin then session gets cleared
        if (sessionStorage.getItem("login-session-expired")) {
          let currentLanguage =
            sessionStorage.getItem("languageTypeOfApp") || "en-us";
          localStorage.clear();
          sessionStorage.clear();
          sessionStorage.setItem("languageTypeOfApp", currentLanguage);
          localStorage.setItem("logout", "true");
        }
      }
    );
  };

  handleTermsClose = () => {
    this.setState({
      isTermsVisible: false,
    });
  };

  redirectToHome = () => {
    this.props.history.push("/home");
  };

  /**
   * This method is used to handle pick survey popup close
   *
   */
  handlePickSurveyClose = () => {
    this.setState({
      isPickSurveyVisible: false,
    });
  };

  handleSelectSurvey = (surveyType: any) => {
    let recoResult = localStorage.getObj("reco-result");
    let isConsentAccepted = localStorage.getItem("user-consent");
    let isAssessmentContinued = sessionStorage.getItem("foundationalPageCount");
    //  localStorage.setItem("surveyType", surveyType);

    this.setState(
      {
        isPickSurveyVisible: false,
        surveyPath: surveyType,
      },
      () => {
        //handle retake assessment
        if ((recoResult || isAssessmentContinued) && isConsentAccepted) {
          this.setState({
            isPopupOpen: true,
            isCopyLinkPopUpOpen: false,
          });
        }
      }
    );
  };

  render() {
    const {
      hamburgerVisible,
      successfullyCopied,
      isCopyLinkPopUpOpen,
      isPickSurveyVisible,
      surveyPath,
    } = this.state;
    const { foodsLoader, productsLoader, tipsLoader } = this.props;
    let totalCartProductsCount: any = localStorage.getItem(
      "totalCartProductsCount"
    );
    totalCartProductsCount = totalCartProductsCount
      ? parseInt(totalCartProductsCount)
      : 0;
    // let hamburgerClass = "hamburger-container hide";
    // // if (!hamburgerVisible) {
    // //   hamburgerClass = "hamburger-container animated slideInUp";
    // // }
    // if (hamburgerVisible) {
    //   hamburgerClass = "hamburger-container animated slideInDown";
    // }

    // Check is Assessment Done
    let isAssessmentDone = localStorage.getObj("reco-result");
    let isAssessmentContinued = sessionStorage.getItem("foundationalPageCount");
    let storageResults = localStorage.getObj("results");
    let surveyType = localStorage.getItem("surveyType");
    let isConsentAccepted = localStorage.getItem("user-consent");
    // let isAssessmentDone =
    //   recoResult && !_.isEmpty(recoResult?.data?.getRecommendation || recoResult?.data?.getRecommendationById )
    //     ? true
    //     : false;

    // Check User account sub type
    let userInfoData = localStorage.getObj("user-info");
    // TEMP OVERRIDE (2026-09-02): forcing Share Assessment visible for everyone
    // while the Gluu/MDMS additionalAudience access issue is unresolved on
    // Amway's side (accountSubType isn't reliably populating). Remove the
    // `true ||` below once that's confirmed fixed to restore normal behavior.
    let userAccountSubType =
      true ||
      (userInfoData &&
        userInfoData?.partyId &&
        userInfoData?.accountSubType?.toLowerCase() === "businessowner")
        ? true
        : false;

    const languageType = sessionStorage.getItem("languageTypeOfApp") || "en-us";
    const { authState } = this.props;
    return (
      <>
        {/* Focus Path Start */}
        {isPickSurveyVisible && (
          <PickSurveyComponent
            {...this.props}
            show={isPickSurveyVisible}
            handleClose={this.handlePickSurveyClose}
            handleSelectSurvey={(surveyType: any) =>
              this.handleSelectSurvey(surveyType)
            }
          />
        )}
        {/* Focus Path Ends */}

        <header className="inner-wrapper">
          {/* Add to Cart Success Message Start */}
          {successfullyCopied ? (
            <MessageStrip messageText={this.props.t("common.link_copied")} />
          ) : null}
          {isCopyLinkPopUpOpen && (
            <SaveResultsPopup
              {...this.props}
              open={isCopyLinkPopUpOpen}
              close={this.closePopup}
              popupTitle={this.props.t("common.link_popup_title")}
              popupMessage={this.state.linkToBeCopied}
              popupFirstButton={false}
              popupFirstButtonType="linkshare"
            />
          )}
          <div className="header-title-wrapper">
            <span
              className="icon nutrilite-logo"
              onClick={() => this.redirectToHome()}
            ></span>
          </div>
          {/* Retake Assessment popup starts here */}
          <SaveResultsPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            surveyType={surveyPath}
            popupTitle={this.props.t("common.hold_on")}
            popupMessage={this.props.t("common.retake_assessment_message")}
            popupFirstButton={this.props.t("common.retake_assessment")}
            popupFirstButtonType="retake-assessment"
          />
          {/* Retake Assessment popup ends here */}

          {/* Header Links wrapper begins */}
          {storageResults &&
            !foodsLoader &&
            !tipsLoader &&
            !productsLoader &&
            surveyType === "fullSurvey" ? (
            <div className="header-links-wrapper">
              <div
                tabIndex={0}
                role="link"
                id={"myResults"}
                className={
                  window.location.pathname === "/home"
                    ? "link"
                    : this.props?.selectedType
                      ? "link"
                      : "link active"
                }
                onClick={() => this.executeCallback("Results")}
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.executeCallback("Results", e);
                  }
                }}
              >
                {this.props.t("common.my_results")}
                <div className="vertical-line"></div>
              </div>
              <div
                tabIndex={0}
                role="link"
                id={"myFoods"}
                className={
                  this.props?.selectedType === "Foods" ? "link active" : "link"
                }
                onClick={() => this.executeCallback("Foods")}
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.executeCallback("Foods", e);
                  }
                }}
              >
                {this.props.t("common.my_foods")}
                <div className="vertical-line"></div>
              </div>
              <div
                tabIndex={0}
                role="link"
                id={"myProducts"}
                className={
                  this.props?.selectedType === "Products"
                    ? "link active"
                    : "link"
                }
                onClick={() => this.executeCallback("Products")}
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.executeCallback("Products", e);
                  }
                }}
              >
                {this.props.t("common.my_products")}
                <div className="vertical-line"></div>
              </div>
              <div
                tabIndex={0}
                role="link"
                id={"myTips"}
                className={
                  this.props?.selectedType === "Tips" ? "link active" : "link"
                }
                onClick={() => this.executeCallback("Tips")}
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.executeCallback("Tips", e);
                  }
                }}
              >
                {this.props.t("common.my_tips")}
                <div className="vertical-line"></div>
              </div>
            </div>
          ) : null}
          {/* Header Links wrapper Ends */}

          {/* Header Icons wrapper Start */}
          <div className="header-icons">
            <div
              className="icon-wrapper"
              onClick={this.props.handleCartClick}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  this.props.handleCartClick();
                }
              }}
            >
              {isAssessmentDone ? (
                <span
                  id="shoppingCart"
                  role="button"
                  aria-expanded="false"
                  aria-haspopup="true"
                  tabIndex={0}
                  aria-label="Shopping cart"
                  className="icon cart-icon active"
                >
                  <div
                    className={totalCartProductsCount > 0 ? "count" : "hide"}
                  >
                    {totalCartProductsCount}
                  </div>
                </span>
              ) : null}
            </div>
            <div
              id="hamburgerMenu"
              role="button"
              tabIndex={0}
              aria-expanded={this.state.hamburgerVisible}
              aria-haspopup="true"
              aria-label="hamburger icon"
              className="icon-wrapper"
              onClick={this.handleHambuurgerMenu}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  this.handleHambuurgerMenu(e);
                }
              }}
            >
              <span className="icon hamburger-icon"></span>
            </div>
          </div>
          {/* Header Icons wrapper Ends */}
          {/* Hamburger Area Start */}
          {/* {hamburgerVisible ? ( */}
          <div
            className={hamburgerVisible ? "hamburger-container" : "hide"} //hamburgerClass
            ref={(node) => {
              this.node = node;
            }}
          >
            <div className="hamburger-wrapper">
              {storageResults &&
                !foodsLoader &&
                !tipsLoader &&
                !productsLoader &&
                surveyType === "fullSurvey" ? (
                <div className="menu-options visible-myoption">
                  <li
                    tabIndex={0}
                    role="menuitem"
                    id={"myResults"}
                    className="option"
                    onClick={() => this.executeCallback("Results")}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        this.executeCallback("Results", e);
                      }
                    }}
                  >
                    {this.props.t("common.my_results")}
                  </li>
                  <li
                    tabIndex={0}
                    role="menuitem"
                    id={"myFoods"}
                    className="option"
                    onClick={() => this.executeCallback("Foods")}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        this.executeCallback("Foods", e);
                      }
                    }}
                  >
                    {this.props.t("common.my_foods")}
                  </li>
                  <li
                    tabIndex={0}
                    role="menuitem"
                    id={"myProducts"}
                    className="option"
                    onClick={() => this.executeCallback("Products")}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        this.executeCallback("Products", e);
                      }
                    }}
                  >
                    {this.props.t("common.my_products")}
                  </li>
                  <li
                    tabIndex={0}
                    role="menuitem"
                    id={"myTips"}
                    className="option"
                    onClick={() => this.executeCallback("Tips")}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        this.executeCallback("Tips", e);
                      }
                    }}
                  >
                    {this.props.t("common.my_tips")}
                  </li>
                </div>
              ) : null}
              <div className="menu-options">
                <li
                  tabIndex={0}
                  role="menuitem"
                  className="option"
                  onClick={this.handleAssessmentClick}
                  onKeyPress={(e: any) => {
                    if (e.key === "Enter") {
                      this.handleAssessmentClick();
                    }
                  }}
                >
                  {/* {isAssessmentContinued &&
                   !isAssessmentDone &&
                   isConsentAccepted
                     ? this.props.t("common.keep_going")
                     : isAssessmentDone && isConsentAccepted
                     ? this.props.t("common.retake_assessment")
                     : this.props.t("common.take_survey")} */}
                  {(isAssessmentContinued || isAssessmentDone) && isConsentAccepted
                    ? this.props.t("common.retake_assessment")
                    : this.props.t("common.take_survey")}
                </li>
                {userAccountSubType ? (
                  <li
                    tabIndex={0}
                    role="menuitem"
                    className="option"
                    onClick={this.handleShareAssessment}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        this.handleShareAssessment(e);
                      }
                    }}
                  >
                    {this.props.t("common.share_assessment")}
                  </li>
                ) : null}
              </div>
              <div className="menu-options">
                {!window.location.pathname.includes("summary") && (
                  <li
                    tabIndex={0}
                    role="menuitem"
                    className="option"
                    onClick={this.updateContentLanguageOnClick}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        this.updateContentLanguageOnClick(e);
                      }
                    }}
                  >
                    {languageType === "en-us"
                      ? this.props.t("common.spanish_label")
                      : this.props.t("common.english_label")}
                  </li>
                )}
                {authState && authState.isAuthenticated ? (
                  <li
                    tabIndex={0}
                    className="option"
                    onClick={() => {
                      window.open(
                        `${process.env.REACT_APP_MY_ACCOUNT_URL}`?.replaceAll(
                          "language",
                          getLanguage() || ""
                        ),
                        "_self"
                      );
                    }}
                  >
                    {this.props.t("common.my_account")}
                  </li>
                ) : null}
                <li
                  tabIndex={0}
                  className="option"
                  role="menuitem"
                  onClick={() =>
                    this.handleUserAuthentication(
                      authState && authState.isAuthenticated
                    )
                  }
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      this.handleUserAuthentication(
                        authState && authState.isAuthenticated,
                        e
                      );
                    }
                  }}
                >
                  {/* authState && authState.isAuthenticated */}
                  {localStorage.getItem("okta-token-storage")
                    ? this.props.t("common.sign_out")
                    : this.props.t("common.sign_in")}
                </li>
              </div>
            </div>
          </div>
          {/* ) : null} */}
          {/* Hamburger Area Ends */}
        </header>
      </>
    );
  }
}

export default withOktaAuth(ResultsHeader);
